// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Vcyx","footer":"Form_footer__132_w"};